import React from 'react';
import { useShutdownAlisaTemplates } from '../../../../../shared/api/queries/shutdownAlisaTemplates';
import { fieldNames } from '../../../common/config';
import { Form } from 'antd';
import { getOptionsBySelect } from '../../lib/getOptionsBySelect';
import { getRenderControl } from '../../../../../../../components/SingleControlCustom/getRenderControl';
import DropdownSelect from '../../../../../../../components/dropdownSelect';

const alisaTemplateFieldName = fieldNames.alisaTemplate;
const FormItem = Form.Item;

const AlisaTemplateField = ({ form, renderAction }) => {
  const { data = [], isFetching } = useShutdownAlisaTemplates({
    staleTime: Infinity,
  });

  const options = getOptionsBySelect(data);

  const hasAction = typeof renderAction === 'function';

  const handleChange = (value) => {
    if (data?.length) {
      const template = data.find((template) => template.id === value);

      if (template) {
        const formattedText = template.text.replace(/\\n/g, '\n');

        form.setFieldsValue({
          [fieldNames.alisaText]: formattedText.startsWith('\n')
            ? formattedText.slice(1)
            : formattedText,
        });
      }
    }
  };

  return (
    <FormItem
      label="Шаблон автоответа"
      style={{ flex: 1, margin: 0 }}
    >
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'start',
          gap: '10px',
        }}
      >
        {form.getFieldDecorator(alisaTemplateFieldName)(
          <DropdownSelect
            onChange={handleChange}
            multiple={false}
            options={options}
            renderControl={getRenderControl({
              options: options,
              isClear: false,
              value: form.getFieldValue(alisaTemplateFieldName),
              disabled: isFetching,
              loading: isFetching,
            })}
          />
        )}
        {hasAction && renderAction()}
      </div>
    </FormItem>
  );
};

export default AlisaTemplateField;
